// 全部都有的字段
let basics = [
  'comment',
  'isPassed',
  'errorMessage',
]
// 多次重用组合
let evidences = [
  'evidences',
]
export default {
  info: [...basics, ...evidences].sort(),
  text: [...basics, ...evidences, 'text'].sort(),
  multitext: [...basics, 'texts'].sort(),
  multiselect: [...basics, ...evidences, 'selectedOptionId'].sort(),
  imageMultiselect: [...basics, ...evidences, 'selectedOptionId'].sort(),
  select: [...basics, ...evidences, 'selectedOptionId'].sort(),
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/answer-types.js